import React from "react";
import "./social-media-share.m.css";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import get from "lodash/get";

const SOCIAL_MEDIA_SHARE = [
  { name: "whatsapp", type: "whatsappicon", bgColor: "#24d366" },
  { name: "facebook", type: "facebookicon", bgColor: "#32529f" },
  { name: "twitter", type: "twittericon", bgColor: "#1ea1f1" },
  { name: "linkedin", type: "linkedinicon", bgColor: "#0277b5" },
  { name: "pinterest", type: "pinteresticon", bgColor: "#e60022" },
  { name: "mail", type: "mailicon", bgColor: "#000000" }
];

const socialMediaUrl = (type, headline, publishedURL) => {
  const encodedHeadline = encodeURIComponent(headline);
  let url;

  switch (type) {
    case "facebook":
      url = `http://en-gb.facebook.com/sharer/sharer.php?utm_source=prajavani&utm_medium=facebook&u=${encodeURIComponent(
        publishedURL + "?utm_source=facebook&utm_medium=referral&utm_campaign=socialshare"
      )}&t=${encodedHeadline}`;
      break;
    case "twitter":
      url = `https://twitter.com/intent/tweet?utm_source=prajavani&utm_medium=twitter&url=${encodeURIComponent(
        publishedURL + "?utm_source=twitter&utm_medium=referral&utm_campaign=socialshare"
      )}&text=${encodedHeadline}&via=prajavani`;
      break;
    case "whatsapp":
      url = `https://api.whatsapp.com/send?utm_source=prajavani&utm_medium=whatsapp&text=${encodedHeadline} ${encodeURIComponent(
        publishedURL + "?utm_source=whatsapp&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;
    case "linkedin":
      url = `http://www.linkedin.com/shareArticle?utm_source=prajavani&utm_medium=linkedin&mini=true&title=${encodedHeadline}
      &url=${encodeURIComponent(publishedURL + "?utm_source=linkedin&utm_medium=referral&utm_campaign=socialshare")}`;
      break;
    case "mail":
      url = `mailto:?subject=${encodedHeadline}&body=${encodedHeadline}:%20${encodeURIComponent(
        publishedURL + "?utm_source=mail&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;
    case "pinterest":
      url = `https://in.pinterest.com/search/pins/?q=domain:https://prajavani.net/`;
      break;

    default:
      url = "";
      break;
  }
  return url;
};

const SocialMediaShare = ({ story }) => {
  const { headline, url } = story;
  const altSocialHeadline = get(story, ["alternative", "social", "default", "headline"], headline);

  return (
    <div styleName="social-wrapper">
      {SOCIAL_MEDIA_SHARE.map((share, index) => (
        <a
          key={index}
          style={{ backgroundColor: `${share.bgColor}` }}
          target="_blank"
          rel="nofollow noreferrer"
          href={socialMediaUrl(share.name, altSocialHeadline, url)}
        >
          <SvgIconHandler type={share.type} />
        </a>
      ))}
    </div>
  );
};

export default SocialMediaShare;
